import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, IconButton, Tooltip, Typography, Button } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import CloseIcon from '@material-ui/icons/Close';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import tableImage from '../../statics/images/table.png';

const useStyles = makeStyles((theme) => ({
    tableRow: {
        width: "75%",
        maxWidth: "75%",
        margin: "10px auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    tableRowItem: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    tableCenterStack: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        width: "100%",
    },
    playerIcon: {
        fontSize: "clamp(80px, 12vw, 200px)",
        color: theme.palette.text.primary,
        stroke: '#aaa',
        strokeWidth: '0.1px',
    },
    playerIconButton: {
        padding: 0,
        '&:hover': {
            backgroundColor: 'transparent',
        },
        '&:focus': {
            backgroundColor: 'transparent',
        },
        '&:active': {
            backgroundColor: 'transparent',
        },
    },
    pingPongBall: {
        width: '23px',
        minWidth: '23px',
        height: '23px',
        minHeight: '23px',
        borderRadius: '50%',
        border: '0px solid #999',
        margin: '5px auto',
        zIndex: 10,
    },
    tableImage: {
        height: "clamp(35px, 5.5vw, 70px)",
        width: "auto",
        objectFit: "contain",
    },
    swapActionButton: {
        paddingLeft: "30px",
        paddingRight: "20px",
        borderRadius: "20px",
    },
    actionButton: {
        paddingLeft: "10px",
        paddingRight: "10px",
        borderRadius: "20px",
        marginLeft: "1vw",
        marginRight: "1vw",
        marginBottom: "5px",
        maxWidth: "250px",
    },
    modalButtonGroup: {
        marginTop: "15px",
        marginBottom: "10px",
    },
}));

function PlayerConfiguration({
    swapped,
    teamAColour,
    teamBColour,
    playerAName,
    playerBName,
    serveA,
    onSetServerA,
    onSwap,
    onCancel,
    onStart,
    t,
}) {
    const classes = useStyles();

    return (
        <>
            <h2 style={{ marginBottom: "0px" }}>{t('playerConfiguration')}</h2>
            <p style={{ marginBottom: "10px", fontSize: "14px" }}>{t('clickOnPlayersToSelectServe')}</p>
            <div>
                <Grid container className={classes.tableRow} alignItems="center" justify="space-between">
                    <Grid item xs={3} className={classes.tableRowItem}>
                        <div>
                            <Tooltip title={t('clickToSelectServer')} arrow open={serveA === swapped} placement="top-start">
                                <IconButton onClick={() => onSetServerA(!swapped)} className={classes.playerIconButton} disableRipple>
                                    <PersonIcon className={classes.playerIcon} style={{ color: swapped ? teamBColour : teamAColour }} />
                                </IconButton>
                            </Tooltip>
                            <Typography>{swapped ? playerBName : playerAName}</Typography>
                        </div>
                        <div className={classes.pingPongBall} style={{ backgroundColor: serveA === !swapped ? 'orange' : 'transparent' }} />
                    </Grid>
                    
                    <Grid item xs={6} className={classes.tableRowItem}>
                        <div className={classes.tableCenterStack}>
                            <img src={tableImage} alt={t("table") || "table"} className={classes.tableImage} />
                            <Button style={{ marginTop: "5px" }}
                                className={classes.swapActionButton}
                                variant="contained"
                                color="default"
                                onClick={onSwap}
                                startIcon={<SwapHorizIcon />}>
                            </Button>
                        </div>
                    </Grid>
                    
                    <Grid item xs={3} className={classes.tableRowItem}>
                        <div className={classes.pingPongBall} style={{ backgroundColor: serveA === swapped ? 'orange' : 'transparent' }} />
                        <div>
                            <Tooltip title={t('clickToSelectServer')} arrow open={serveA !== swapped} placement="top-end">
                                <IconButton onClick={() => onSetServerA(swapped)} className={classes.playerIconButton} disableRipple>
                                    <PersonIcon className={classes.playerIcon} style={{ color: swapped ? teamAColour : teamBColour }} />
                                </IconButton>
                            </Tooltip>
                            <Typography>{swapped ? playerAName : playerBName}</Typography>
                        </div>
                    </Grid>
                </Grid>
            </div>

            <div className={classes.modalButtonGroup}>
                <Button style={{ marginRight: "5px" }}
                    className={classes.actionButton}
                    variant="contained"
                    color="secondary"
                    onClick={onCancel}
                    startIcon={<CloseIcon />}>
                    {t('cancel')}
                </Button>

                <Button style={{ marginLeft: "5px" }}
                    className={classes.actionButton}
                    variant="contained"
                    color="primary"
                    onClick={onStart}
                    startIcon={<NavigateNextIcon />}>
                    {t('startNow')}
                </Button>
            </div>
        </>
    );
}

export default PlayerConfiguration;
